<template>
  <section class="filter-categories-selection" data-test="selected_filters">
    <v-chip
      v-for="filter in selectionFilterItems"
      :key="filter.id"
      close
      outlined
      @click:close="onClose(filter.parent.external_id, filter.external_id)"
    >
      <span v-if="filter.external_id === 'study_vocabulary'">
        <b> {{ $i18n.locale === "en" ? "All professional vocabularies" : "Alle vakvocabulaires" }}</b>
      </span>
      <span v-else-if="filter.field === 'study_vocabulary'">
        {{ $i18n.locale === "en" ? "Professional vocabulary:" : "Vakvocabulaire:" }}
        <b>{{ filter.translation[$i18n.locale] }}</b>
      </span>
      <span v-else>
        <span v-if="filter.parent">{{ filter.parent.translation[$i18n.locale] }}:</span>
        <span
          ><b>{{ filter.translation[$i18n.locale] }}</b></span
        >
      </span>
    </v-chip>
    <v-btn v-show="selectionFilterItems.length" outlined depressed data-test="reset_filters" @click="resetFilter">
      {{ $t("Reset-filters") }}
    </v-btn>
  </section>
</template>

<script>
import { flatMap, isEmpty } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "FilterCategoriesSelection",
  props: {
    materials: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["getCategoryById", "selected_filters"]),
    selectionFilterItems() {
      if (isEmpty(this.selected_filters)) {
        return [];
      }

      return flatMap(this.selected_filters, (filter_ids, categoryId) => {
        const category = this.getCategoryById(categoryId, null);
        const results = filter_ids.map((filter_id) => {
          if (category && categoryId == "study_vocabulary" && filter_id == "all") {
            category.parent = category;
            return category;
          } else {
            return this.findFilter(category, filter_id);
          }
        });
        return results.filter((rsl) => rsl);
      });
    },
  },
  methods: {
    onClose(categoryId, itemId) {
      if (categoryId == "study_vocabulary") {
        this.$store.commit("RESET_FILTER_CATEGORIES_SELECTION");
        this.$store.dispatch("getVocabularies");
      } else {
        this.$store.commit("DESELECT_FILTER_CATEGORIES", { category: categoryId, selection: [itemId] });
      }
      this.$emit("filter");
    },
    resetFilter() {
      this.$store.commit("RESET_FILTER_CATEGORIES_SELECTION");
      this.$store.dispatch("getVocabularies");
      this.$emit("filter");
    },
    findFilter(category, filter_id) {
      if (category?.external_id === filter_id) {
        return category;
      }

      if (category?.children && category.children.length > 0) {
        for (const child of category.children) {
          const result = this.findFilter(child, filter_id);
          if (result) {
            result.parent = category;
            return result;
          }
        }
      }
      return null;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../variables.less";

.filter-categories-selection {
  margin: 15px auto 0;
  padding: 0 25px;
  max-width: 1116px;

  .v-chip {
    margin: 10px 10px 0 0;
  }
  .v-btn {
    margin-top: 10px;
  }
}
</style>
